import React, { Component } from 'react';
import './Press.css';


class Press extends Component {
  render() {
    return (
      <div className='Press'>

        <div className='spacer'></div>

        <header className="Press-header header">Press</header>

        <div className='spacer'></div>

        <p className="Press-paragraph paragraph">
          <span className='font-serif font-size-1' >Featured on WGSN Women's Knit & Jersey Trend Concepts</span>
          <br />
          <span className='font-serif' ><em>March 2020</em></span>
          <br />
          <br />
Featured on WGSN Women's Knit & Jersey Trend Concepts A/W 21/22: Phantasmagoria (01.03.20)
        </p>
        <img width="100%" src={require('./../../../images/rebirth/rebirth_29.jpg')} />

        <div className='spacer'></div>

        <p className="Press-paragraph paragraph">
          <span className='font-serif font-size-1' >HATRA Bursary Award</span>
          <br />
          <span className='font-serif' ><em>October 2019</em></span>
          <br />
          <br />
          Presented the The HATRA Bursary: <a href="https://www.frameworkknitters.co.uk/student-bursaries/previous-awards/?fbclid=IwAR2DHW6aG1NHXV_fQ03FWkcyvQlmBGqgOlEZSw7YHLFaCc7RJq52MbJJRIk">frameworkknitters.co.uk/student-bursaries</a>
        </p>
        <img width="50%" src={require('./../../../images/press/award_1.jpg')} />
        <img width="50%" src={require('./../../../images/press/award_2.jpg')} />

        <div className='spacer'></div>

        <p className="Press-paragraph paragraph">
          <span className='font-serif font-size-1' >Swatch Featured</span>
          <br />
          <span className='font-serif' ><em>2019</em></span>
          <br />
          <br />
          <a href="https://fashionunited.uk/news/fashion/ss19-knit-and-yarn-directions/2018041129068?fbclid=IwAR3KUvTfkHqF91zbxj9OpfNPQLjackPMoCNIV5lcm0ntw0QBSGnD73cikOc">fashionunited.uk</a>

        </p>

        <div className='spacer'></div>

        <p className="Press-paragraph paragraph">
          <span className='font-serif font-size-1' >WSA Graduate Fasion Show</span>
          <br />
          <span className='font-serif' ><em>London, July 2019</em></span>
          <br />
          <br />
          <a href="https://wsabafashion.com/graduate-show-london-2019/">wsabafashion.com/graduate-show-london-2019</a><br />
          <br />
          <a href="https://fashionlamour.com/2019/06/13/wsa-ba-fashion-design-lfwm-ss20">Fashion L'amour Website</a><br />
          <br />
          <a href="https://www.instagram.com/p/ByuMUSGHrFO/">wsa.ba.fashion Instagram</a>
        </p>
        <img width="100%" src={require('./../../../images/press/wsa_ba_2019.jpg')} />

        <div className='spacer'></div>

        <p className="Press-paragraph paragraph">

        </p>

        <div className='spacer'></div>
      </div>
    );
  }
}

export default Press;


//          <span className='font-serif font-size-1' >Website Launch</span>
//          <br />
//          <span className='font-serif' ><em>May 2019</em></span>
//          <br />
//          <br />
//          New website lauched.